import { Layout, Text } from '@loadsmart/loadsmart-ui'

import { Logo } from 'core/ui/components/logo/Logo'

import { type Shipper } from '../domain/Shipper'

export type ShipperHeaderProps = {
  shipper: Shipper
}

export function ShipperHeader({ shipper }: ShipperHeaderProps): JSX.Element {
  return (
    <Layout.Group space="s" align="center">
      <Logo url={shipper.logoUrl} />
      <Layout.Stack space="xs">
        <Text>Shipper</Text>
        <Text variant="body-bold">{shipper.name}</Text>
      </Layout.Stack>
    </Layout.Group>
  )
}
